import { getValue, setValue } from './select';
import tools from './tools';

// TomSelect component
export default function (states = {}) {
    let root, instance, isSingle, disabledAttributeObserver;
    let instantiated = false;

    return {
        get value() {
            return root._x_model ? root._x_model.get() : instance ? instance.getValue() : getValue(root);
        },

        set value(value) {
            root._x_model ? root._x_model.set(value) : instance ? instance.setValue(value) : setValue(root, value);
        },

        get disabled() {
            return root.disabled;
        },

        set disabled(value) {
            instance ? instance[value ? 'disable' : 'enable']() : (root.disabled = value);
        },

        instance() {
            return instance;
        },

        init() {
            root = this.$root;
            isSingle = root.type === 'select-one';

            if (this.isInModal) {
                this.instantiate();
            }
        },

        destroy() {
            try {
                instance.destroy();
            } catch (error) {}

            disabledAttributeObserver?.disconnect();
        },

        instantiate() {
            if (instantiated) return;
            instantiated = true;

            const computedStyle = window.getComputedStyle(root);
            const height = computedStyle.height;

            const defaultConfig = {
                placeholder: this.placeholder,
                plugins: {},
                render: {
                    option_create(data, escape) {
                        return `<div class="create">${__('Add')} <strong>${escape(data.input)}</strong>&hellip;</div>`;
                    },
                    no_results(data, escape) {
                        return `<div class="no-results">${__('No matches found')}</div>`;
                    },
                },
            };

            let config = states.config ?? {};

            if (typeof config === 'string') {
                config = this[config] || window[config] || {};
            }

            for (const property of ['plugins', 'render']) {
                if (config[property]) {
                    Object.assign(defaultConfig[property], config[property]);
                    delete config[property];
                }
            }

            config = Object.assign(defaultConfig, config);

            if (states.allowClear) {
                Object.assign(config.plugins, {
                    clear_button: {
                        title: isSingle ? __('Clear Selection') : __('Clear All'),
                    },
                });
            }

            if (!isSingle) {
                Object.assign(config.plugins, {
                    remove_button: {
                        title: __('Remove'),
                    },
                });
            }

            instance = new TomSelect(root, config);
            instance.wrapper.classList.remove('custom-select', 'form-select', 'empty-select', 'is-valid', 'is-invalid', 'ts-source-multiple');

            if (!isSingle) {
                instance.control.style.minHeight = height;
            }

            instance.on('focus', () => {
                if (this.events) {
                    this.events['x-on:focusin']({
                        type: 'focusin',
                        target: { name: tools.getName(root) },
                    });
                }
            });

            instance.on('blur', () => {
                if (this.events) {
                    this.events['x-on:focusout']({
                        type: 'focusout',
                        target: { name: tools.getName(root) },
                    });
                }
            });

            if (root.hasAttribute('x-bind:disabled')) {
                const options = {
                    attributes: true,
                    attributeFilter: ['disabled'],
                };

                disabledAttributeObserver = new MutationObserver((mutations) =>
                    mutations.forEach((mutation) => {
                        disabledAttributeObserver.disconnect();
                        this.disabled = mutation.target.hasAttribute('disabled');
                        disabledAttributeObserver.observe(root, options);
                    })
                );

                disabledAttributeObserver.observe(root, options);
            }

            this.$nextTick(() => {
                if (root._x_model) {
                    this.$watch(tools.getXModelValue(root), (value) => instance.setValue(value, true));

                    instance.setValue(root._x_model.get(), true);
                }
            });
        },

        postGenerateOptions() {
            if (!instance) return;

            instance.clear();
            instance.clearOptions();
            instance.sync();
        },
    };
}
